import React, { forwardRef, SVGProps } from 'react';

export const RedCancelIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement> & { css?: any }
>((props, ref) => (
  <svg
    ref={ref}
    width={props?.width || '34'}
    height={props?.height || '24'}
    viewBox="0 0 29 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23 15C26.3137 15 29 12.3137 29 9C29 5.68629 26.3137 3 23 3C19.6863 3 17 5.68629 17 9C17 12.3137 19.6863 15 23 15ZM22.16 6.53672C22.16 6.07461 22.5346 5.7 22.9967 5.7H23.0033C23.4654 5.7 23.84 6.07461 23.84 6.53672C23.84 6.99883 23.4654 7.37344 23.0033 7.37344H22.9967C22.5346 7.37344 22.16 6.99883 22.16 6.53672ZM22.16 9.16172C22.16 8.69961 22.5346 8.325 22.9967 8.325C23.4588 8.325 23.8334 8.69961 23.8334 9.16172V11.7867C23.8334 12.2488 23.4588 12.6234 22.9967 12.6234C22.5346 12.6234 22.16 12.2488 22.16 11.7867V9.16172Z"
      fill="#D9DADE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 9C0 4.02944 4.02944 0 9 0C12.3957 0 15.3521 1.88054 16.8847 4.65698C16.0128 5.88252 15.5 7.38138 15.5 9C15.5 10.6186 16.0128 12.1175 16.8847 13.343C15.3521 16.1195 12.3957 18 9 18C4.02944 18 0 13.9706 0 9ZM11.0701 5.35724C11.4791 4.94821 12.1115 4.8818 12.5556 5.20272L12.6241 5.25661L12.686 5.31396C13.1081 5.73606 13.096 6.41372 12.7016 6.86681L12.6427 6.92995L10.5724 8.99971L12.6428 11.0701C13.0518 11.4791 13.1182 12.1115 12.7973 12.5556L12.7434 12.6241L12.686 12.686C12.2639 13.1081 11.5863 13.096 11.1332 12.7017L11.0701 12.6427L8.9995 10.5721L6.9299 12.6428C6.52087 13.0518 5.88848 13.1182 5.44444 12.7973L5.37595 12.7434L5.31397 12.686C4.89187 12.2639 4.90404 11.5863 5.2983 11.1333L5.35721 11.0701L7.42708 8.99971L5.35725 6.9299C4.94822 6.52087 4.8818 5.88848 5.20272 5.44444L5.25662 5.37595L5.31397 5.31396C5.73606 4.89187 6.41372 4.90404 6.86677 5.29833L6.92991 5.35725L8.9995 7.42679L11.0701 5.35724Z"
      fill="#F46C6C"
    />
  </svg>
));
